import { Accountant } from '@/plugins/api'
import { upsertMany } from '@/helpers'

export default {
  namespaced: true,
  state: {
    accountants: [],
    isLoading: false
  },
  actions: {
    async fetchAccountants({ commit }, options) {
      const res = await Accountant.fetch(options)
      commit('setAccountants', res)
    },
    async fetchAccountant({ commit, state }, { id, options }) {
      const res = await Accountant.fetchOne(id, options)
      commit('setAccountants', upsertMany(state.accountants, res))
    },
    async updateAccountant({ commit, state }, { id, params, options }) {
      const res = await Accountant.update(id, params, options)
      commit('setAccountants', upsertMany(state.accountants, res))
    },
    async createAccountant({ commit, state }, { params, options }) {
      const res = await Accountant.create(params, options)
      commit('setAccountants', upsertMany(state.accountants, res))
    },
    async removeAccountant({ commit, state }, { id, options }) {
      await Accountant.remove(id, options)
      commit(
        'setAccountants',
        state.accountants.filter(i => i.id !== id)
      )
    },
    async swapAccountant({ commit, state }, { id, params, options }) {
      await Accountant.swap(id, params, options)
      commit(
        'setAccountants',
        state.accountants.filter(i => i.id !== id)
      )
    }
  },
  mutations: {
    setAccountants(state, v) {
      state.accountants = v
    }
  }
}
